<aside class="sidebar-float" [class.minimized]="minimized">
  <div class="sidebar-header">
    <div class="sidebar-header-row">
      <span [class]="getHeaderIcon() + ' sidebar-header-logo'"></span>
      @if (!minimized) {
        <div class="sidebar-header-titles">
          <div class="sidebar-title-main">{{ getExpandedMenuName() }}</div>
          <div class="sidebar-title-sub">Sistema de informacion genomico</div>
        </div>
      }
    </div>
    <hr class="sidebar-divider" />
  </div>

  <button class="sidebar-toggle" (click)="toggleSidebar()">
    <i
      class="pi"
      [ngClass]="minimized ? 'pi-angle-right' : 'pi-angle-left'"
    ></i>
  </button>

  <div class="sidebar-content">
    @for (menu of seusMenus; track menu.name; let menuIndex = $index) {
      @if (!minimized || isMenuExpanded(menuIndex)) {
        <div class="sidebar-menu-section">
          @if (!minimized) {
            <div
              class="sidebar-section-title clickable"
              [class.expanded]="isMenuExpanded(menuIndex)"
              (click)="toggleMenu(menuIndex)"
            >
              <span class="section-title-text">{{ menu.name }}</span>
              <i
                class="pi section-toggle-icon"
                [ngClass]="
                  isMenuExpanded(menuIndex) ? 'pi-angle-up' : 'pi-angle-down'
                "
              ></i>
            </div>
          } @else {
            <div class="sidebar-section-title minimized">
              <span class="section-title-text">{{ menu.name }}</span>
            </div>
          }

          @if (isMenuExpanded(menuIndex)) {
            <ul class="sidebar-menu">
              @for (item of menu.menuItems; track item.cdresource) {
                <li
                  class="sidebar-menu-item"
                  [class.has-children]="hasChildren(item)"
                >
                  @if (!hasChildren(item)) {
                    <a
                      [class.active]="isItemActive(item)"
                      [class.sidebar-link--minimized]="minimized"
                      [routerLink]="item.target"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: false }"
                      class="sidebar-menu-link"
                      [pTooltip]="minimized ? item.name : ''"
                      tooltipPosition="right"
                    >
                      <span class="sidebar-dropdown-icon-left">
                        <span
                          [class]="getItemIcon(item) + ' sidebar-dropdown-img'"
                        ></span>
                      </span>
                      @if (!minimized) {
                        <span class="sidebar-link-text">{{ item.name }}</span>
                      }
                    </a>
                  } @else {
                    <div
                      class="sidebar-parent-item sidebar-menu-link"
                      [class.expanded]="isItemExpanded(item)"
                      [class.sidebar-link--minimized]="minimized"
                      (click)="toggleItem(item)"
                      [pTooltip]="minimized ? item.name : ''"
                      tooltipPosition="right"
                    >
                      <span class="sidebar-dropdown-icon-left">
                        <span
                          [class]="getItemIcon(item) + ' sidebar-dropdown-img'"
                        ></span>
                      </span>
                      @if (!minimized) {
                        <span class="sidebar-link-text">{{ item.name }}</span>
                        <span class="sidebar-dropdown-icon">
                          <i
                            class="pi"
                            [ngClass]="
                              isItemExpanded(item)
                                ? 'pi-angle-up'
                                : 'pi-angle-down'
                            "
                          ></i>
                        </span>
                      }
                    </div>
                  }

                  @if (
                    hasChildren(item) && isItemExpanded(item) && !minimized
                  ) {
                    <ul class="sidebar-submenu">
                      @for (child of item.children; track child.cdresource) {
                        <li>
                          <a
                            [routerLink]="child.target"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }"
                            style="position: relative"
                          >
                            <span>{{ child.name }}</span>
                            <i class="pi pi-angle-right"></i>
                          </a>
                        </li>
                      }
                    </ul>
                  }
                </li>
              }
            </ul>
          }
        </div>
      }
    }
  </div>

  <div class="sidebar-footer">
    <div class="sidebar-logo-sura"></div>
  </div>
</aside>
